import { Component, OnInit } from '@angular/core';
import { BciWkModalService } from '@bci/webkitbci';

@Component({
  selector: 'app-modal-cambia-sucursal',
  templateUrl: './modal-cambia-sucursal.component.html',
  styleUrls: ['./modal-cambia-sucursal.component.scss'],
  standalone: false
})
export class ModalCambiaSucursalComponent implements OnInit {
  constructor(private modal: BciWkModalService) {}

  ngOnInit(): void {
    this.modal.setStyles({
      containerStyle: {
        maxWidth: '600px',
        width: '100%',
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: '16px',
        overflowY: 'hidden',
      },
    });
  }

  close() {
    this.modal.close();
  }
}
